module.exports = __webpack_public_path__ + "static/media/belgium.c689bca9.png";